import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

const SocialNetworkList = ({ className, ...props }: ComponentProps<'ul'>) => (
  <ul
    className={cn('preflight preflight-ul mx-auto flex w-full max-w-64 items-center justify-between', className)}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <li>
      <a
        href="https://www.tiktok.com/@zoolife.tv"
        target="_blank"
        rel="noreferrer noopener"
        className="preflight preflight-a block"
      >
        <svg
          className="preflight preflight-svg"
          width="26"
          height="29"
          viewBox="0 0 26 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.2323 0.0241667C14.8153 0 16.3861 0.0120833 17.9569 0C18.0536 1.84875 18.7182 3.73375 20.0715 5.03875C21.4248 6.38 23.334 6.99625 25.1948 7.20167V12.0712C23.4548 12.0108 21.7028 11.6483 20.1198 10.8992C19.4311 10.585 18.7907 10.1863 18.1623 9.77542C18.1503 13.3038 18.1744 16.8321 18.1382 20.3483C18.0415 22.04 17.4857 23.7196 16.5069 25.1092C14.924 27.4292 12.1811 28.9396 9.36567 28.9879C7.63776 29.0846 5.90984 28.6133 4.43567 27.7433C1.99484 26.3054 0.279006 23.6713 0.0252562 20.8438C0.00108955 20.2396 -0.0109938 19.6354 0.0131729 19.0433C0.230673 16.7475 1.36651 14.5483 3.13067 13.05C5.13651 11.31 7.93984 10.4763 10.5619 10.9717C10.5861 12.76 10.5136 14.5483 10.5136 16.3367C9.31734 15.95 7.91567 16.0588 6.86442 16.7838C6.10317 17.2792 5.52317 18.0404 5.22109 18.8983C4.96734 19.5146 5.03984 20.1912 5.05192 20.8438C5.34192 22.8254 7.25109 24.4929 9.28109 24.3117C10.6344 24.2996 11.9273 23.5142 12.6282 22.3663C12.8578 21.9675 13.1115 21.5567 13.1236 21.0854C13.2444 18.9225 13.1961 16.7717 13.2082 14.6088C13.2203 9.73917 13.1961 4.88167 13.2323 0.0241667Z"
            fill="black"
          />
        </svg>
        <span className="sr-only">TikTok</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.facebook.com/zoolifetv"
        target="_blank"
        rel="noreferrer noopener"
        className="preflight preflight-a block"
      >
        <svg
          className="preflight preflight-svg"
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.31607 3.44129 0 4.20435 0 5L0 27C0 27.7956 0.31607 28.5587 0.87868 29.1213C1.44129 29.6839 2.20435 30 3 30H11.5781V20.4806H7.64062V16H11.5781V12.585C11.5781 8.70062 13.8906 6.555 17.4325 6.555C19.1287 6.555 20.9025 6.8575 20.9025 6.8575V10.67H18.9481C17.0225 10.67 16.4219 11.865 16.4219 13.0906V16H20.7206L20.0331 20.4806H16.4219V30H25C25.7956 30 26.5587 29.6839 27.1213 29.1213C27.6839 28.5587 28 27.7956 28 27V5C28 4.20435 27.6839 3.44129 27.1213 2.87868C26.5587 2.31607 25.7956 2 25 2Z"
            fill="#212121"
          />
        </svg>
        <span className="sr-only">Facebook</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com/zoolife.tv"
        target="_blank"
        rel="noreferrer noopener"
        className="preflight preflight-a block"
      >
        <svg
          className="preflight preflight-svg"
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_408_10845)">
            <path
              d="M14.0063 8.81251C10.0313 8.81251 6.82505 12.0188 6.82505 15.9938C6.82505 19.9688 10.0313 23.175 14.0063 23.175C17.9813 23.175 21.1875 19.9688 21.1875 15.9938C21.1875 12.0188 17.9813 8.81251 14.0063 8.81251ZM14.0063 20.6625C11.4375 20.6625 9.33755 18.5688 9.33755 15.9938C9.33755 13.4188 11.4313 11.325 14.0063 11.325C16.5813 11.325 18.675 13.4188 18.675 15.9938C18.675 18.5688 16.575 20.6625 14.0063 20.6625ZM23.1563 8.51876C23.1563 9.45001 22.4063 10.1938 21.4813 10.1938C20.5501 10.1938 19.8063 9.44376 19.8063 8.51876C19.8063 7.59376 20.5563 6.84376 21.4813 6.84376C22.4063 6.84376 23.1563 7.59376 23.1563 8.51876ZM27.9125 10.2188C27.8063 7.97501 27.2938 5.98751 25.65 4.35001C24.0125 2.71251 22.025 2.20001 19.7813 2.08751C17.4688 1.95626 10.5375 1.95626 8.22505 2.08751C5.98755 2.19376 4.00005 2.70626 2.3563 4.34376C0.712549 5.98126 0.206299 7.96876 0.0937988 10.2125C-0.0374512 12.525 -0.0374512 19.4563 0.0937988 21.7688C0.200049 24.0125 0.712549 26 2.3563 27.6375C4.00005 29.275 5.9813 29.7875 8.22505 29.9C10.5375 30.0313 17.4688 30.0313 19.7813 29.9C22.025 29.7938 24.0125 29.2813 25.65 27.6375C27.2875 26 27.8001 24.0125 27.9125 21.7688C28.0438 19.4563 28.0438 12.5313 27.9125 10.2188ZM24.925 24.25C24.4375 25.475 23.4938 26.4188 22.2626 26.9125C20.4188 27.6438 16.0438 27.475 14.0063 27.475C11.9688 27.475 7.58755 27.6375 5.75005 26.9125C4.52505 26.425 3.5813 25.4813 3.08755 24.25C2.3563 22.4063 2.52505 18.0313 2.52505 15.9938C2.52505 13.9563 2.36255 9.57501 3.08755 7.73751C3.57505 6.51251 4.5188 5.56876 5.75005 5.07501C7.5938 4.34376 11.9688 4.51251 14.0063 4.51251C16.0438 4.51251 20.4251 4.35001 22.2626 5.07501C23.4876 5.56251 24.4313 6.50626 24.925 7.73751C25.6563 9.58126 25.4875 13.9563 25.4875 15.9938C25.4875 18.0313 25.6563 22.4125 24.925 24.25Z"
              fill="#212121"
            />
          </g>
          <defs>
            <clipPath id="clip0_408_10845">
              <rect width="28" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span className="sr-only">Instagram</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.youtube.com/@zoolifetv"
        target="_blank"
        rel="noreferrer noopener"
        className="preflight preflight-a block"
      >
        <svg
          className="preflight preflight-svg"
          width="49"
          height="28"
          viewBox="0 0 49 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_408_10847)">
            <path
              d="M48.4833 6.03556C48.4833 6.03556 48.005 3.29778 46.5317 2.08444C44.6758 0.497778 42.5903 0.497778 41.6145 0.404444C34.7851 0 24.5104 0 24.5104 0H24.4913C24.4913 0 14.2168 0 7.34798 0.404444C6.39133 0.497778 4.30577 0.497778 2.43076 2.08444C0.976644 3.29778 0.498319 6.03556 0.498319 6.03556C0.498319 6.03556 0.000854492 9.27111 0.000854492 12.4911V15.5089C0.000854492 18.7289 0.498319 21.9489 0.498319 21.9489C0.498319 21.9489 0.976644 24.6867 2.4499 25.9C4.30577 27.4867 6.75482 27.44 7.84545 27.5956C11.7677 27.9067 24.4913 28 24.4913 28C24.4913 28 34.7849 27.9844 41.6346 27.58C42.5912 27.4867 44.6768 27.4867 46.5518 25.9C48.0251 24.6867 48.5034 21.9489 48.5034 21.9489C48.5034 21.9489 48.9991 18.7289 48.9991 15.5089V12.4911C48.98 9.27111 48.4825 6.03556 48.4825 6.03556H48.4833ZM19.4393 19.1644V7.98L32.6793 13.5956L19.4393 19.1644Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_408_10847">
              <rect width="49" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <span className="sr-only">YouTube</span>
      </a>
    </li>
  </ul>
);

export default SocialNetworkList;
